import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await login(email, password);
      toast.success('Zalogowano pomyślnie');
      navigate('/');
    } catch (error) {
      toast.error('Błędne dane logowania');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 p-4">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div>
      </div>
      
      <Card data-testid="login-card" className="w-full max-w-md relative z-10 bg-zinc-900/80 backdrop-blur-xl border-zinc-800">
        <CardHeader className="space-y-1 text-center">
          <div className="mx-auto mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_avebar-screens/artifacts/ok83t4x1_avepark%20logo.svg" 
              alt="AvePark Logo" 
              className="h-20 w-auto mx-auto"
            />
          </div>
          <CardTitle className="text-3xl font-bold text-white">Panel Administracyjny</CardTitle>
          <CardDescription className="text-zinc-400">System zarządzania wyświetlaczami</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-zinc-200">Email</Label>
              <Input
                data-testid="email-input"
                id="email"
                type="email"
                placeholder="admin@avepark.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-zinc-800/50 border-zinc-700 text-white placeholder:text-zinc-500"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-zinc-200">Hasło</Label>
              <Input
                data-testid="password-input"
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-zinc-800/50 border-zinc-700 text-white placeholder:text-zinc-500"
              />
            </div>
            <Button
              data-testid="login-button"
              type="submit"
              className="w-full btn-primary"
              disabled={loading}
            >
              {loading ? 'Logowanie...' : 'Zaloguj się'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
